export const PROFILE_SETTINGS_INIT_FORM_REQUEST = 'PROFILE_SETTINGS_INIT_FORM_REQUEST';
export const PROFILE_SETTINGS_INIT_FORM_SUCCESS = 'PROFILE_SETTINGS_INIT_FORM_SUCCESS';
export const PROFILE_SETTINGS_UPDATE_PROFILE_REQUEST = 'PROFILE_SETTINGS_UPDATE_PROFILE_REQUEST';
export const PROFILE_SETTINGS_UPDATE_PROFILE_SUCCESS = 'PROFILE_SETTINGS_UPDATE_PROFILE_SUCCESS';